<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import type { Purchase } from '../../modules/paymentsApi/purchases/purchase.entity'
    import Zinput from '../_common/z/zinput.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import { ChangePurchaseDueDateInputDto, ChangePurchaseDueDateOutputDto } from '../../modules/paymentsApi/purchases/dto/change-purchase-due-date.dto'
    import ZContainer from '../_common/z/z-container.svelte'
    import dayjs from 'dayjs'
    import Zbutton from '../_common/z/zbutton.svelte'

    // ##############################################################################################################
    const dispatch = createEventDispatcher()

    export let purchaseId: string

    let entity: ChangePurchaseDueDateInputDto = new ChangePurchaseDueDateInputDto()
    entity.simulation = true
    let purchase: Purchase = null

    async function loadPurchase() {
        purchase = await window.api.payments.purchases.getOne(purchaseId)
    }

    onMount(async () => {
        await loadPurchase()
    })

    let step = 1

    let newValue: number
    async function goSave() {
        try {
            entity.simulation = false
            await window.api.payments.purchases.changeValue(purchase.purchaseId, { newValue })
            dispatch('close')
        } catch (error) {
            window.error(error.message || error)
        }
    }

    let options = []
    for (let index = 1; index <= 28; index++) {
        options.push({
            value: index,
            label: index,
        })
    }
</script>

<div class="root">
    <Zact>
        <div class="spacer" />
        {#if window.store.token.permissions.account.users.write}
            <Zbutton label="Alterar" color="green" on:click={goSave}></Zbutton>
        {/if}
    </Zact>
    <Zframe title="Novo valor" class="m-3">
        <ZContainer>
            <Zinput size={12} label="Novo valor" type="number" bind:value={newValue}></Zinput>
        </ZContainer>
    </Zframe>
</div>
